import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { SlideTitle, SlideText } from 'johari/ui/atoms';
import UserAvatar from 'johari/ui/components/UserAvatar';

const JohariPageSlide1 = ({ user = {} }) => {
  const { avatar, firstName, birthDate, gender } = user;
  const age = moment().diff(birthDate, 'years');
  const { t } = useTranslation();

  return (
    <>
      <AvatarCont>
        <UserAvatar avatar={avatar} firstName={firstName} />
        <Name>
          {firstName}, {age}
        </Name>
      </AvatarCont>
      <SlideTitle>{t('greeting')}</SlideTitle>
      <SlideText style={{ maxWidth: 340 }}>
        {t(`greetingText${gender === 'FEMALE' ? 'Female' : ''}`, { firstName })}
      </SlideText>
    </>
  );
};

const Name = styled(SlideText)`
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  margin-bottom: 60px;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.6);
  ${(p) => p.theme.max('sm')`
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 40px;
  `};
`;

const AvatarCont = styled.div`
  margin-top: 33px;
`;

JohariPageSlide1.propTypes = {
  nextSlide: PropTypes.func,
  user: PropTypes.object,
};

export default JohariPageSlide1;
